export const en = {
    add_cost_center: 'Add a cost center',
    const_center_name: 'Cost center name',
};
